import './AggregateData.scss';

import React, { useEffect, useState } from 'react';
import {connect} from "react-redux";
import { routerActions } from "react-router-redux";
import moment from 'moment';

import {getAggregateData, sendAggregateData} from "./store/actions";

import PageContent from "../../components/PageContent";
import Button from "../../components/Button";
import {formatDollarAmount} from "../../utils/data";
import ConfirmModal from "../../components/Modal/ConfirmModal";

const GLOBAL_COLUMNS = [
    {
        name: 'herdSize',
        text: 'Herd Size'
    }, {
        name: 'count',
        text: 'Count'
    }, {
        name: 'profitPerCow',
        text: 'Profit / Cow',
        type: 'dollar'
    }, {
        name: 'averageBasis',
        text: 'Average Basis',
        type: 'dollar'
    }, {
        name: 'averageProduction',
        text: 'Average Production'
    }, {
        name: 'averageHerdSize',
        text: 'Average Herd Size'
    }, {
        name: 'averageProfitability',
        text: 'Average Profitability'
    }
];

const REGIONAL_COLUMNS = [
    {
        name: 'herdSize',
        text: 'Herd Size'
    }, {
        name: 'count',
        text: 'Count'
    }, {
        name: 'profitPerCow',
        text: 'Profit / Cow',
        type: 'dollar'
    }, {
        name: 'averageBasis',
        text: 'Average Basis',
        type: 'dollar'
    }, {
        name: 'averageProduction',
        text: 'Average Production'
    }, {
        name: 'averageProfitability',
        text: 'Average Profitability'
    }
];

const REGIONAL_ORDER = ['midwest', 'northeast', 'northwest', 'southeast', 'southwest'];

const AggregateData = ({aggregateData: { computedAt, globalData, isSendingAggregateData, regionalData }, auth, changeLocation, getAggregateData, sendAggregateData}) => {
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    useEffect(() => {
        const initialize = async () => {
            try {
                await getAggregateData();
            } catch(err) {
                console.log('AggregateData initialize err', err);
            }
        };

        initialize();
    }, []);

    const handleConfirmDownload = async () => {
        try {
            await sendAggregateData();
            setShowConfirmModal(false);
            setTimeout(() => setShowSuccessModal(true), 300);
        } catch(err) {
            console.log('AggregateData handleConfirmDownload err', err);
            setShowConfirmModal(false);
        }
    };

    const renderDollarAmount = (dollarAmount) => {
        let formattedDollarAmount = formatDollarAmount(dollarAmount);

        if(dollarAmount < 0) {
            return `(${formattedDollarAmount.replace('-', '')})`;
        }

        return formattedDollarAmount;
    };

    const renderHerdSize = (row) => {
        let herdSizeString;
        if(row.herdSizeMin == null || row.herdSizeMin === 0) {
            herdSizeString = `Under ${row.herdSizeMax.toLocaleString()}`;
        } else if(row.herdSizeMax == null) {
            herdSizeString = `Above ${(row.herdSizeMin - 1).toLocaleString()}`;
        } else {
            herdSizeString = `${row.herdSizeMin.toLocaleString()}-${row.herdSizeMax.toLocaleString()}`;
        }
        return herdSizeString;
    };

    return (
        <PageContent className="aggregate-data">
            <Button
                onClick={() => setShowConfirmModal(true)}
            >
                Download All Data
            </Button>

            <h2>
                Regional Profit
            </h2>

            {computedAt && (
                <div className="aggregate-date__computed-at">
                    Computed at: {moment(computedAt).format('MM/DD/YYYY [at] hh:mma')}
                </div>
            )}

            <div className="aggregate-data__tables">
                {REGIONAL_ORDER.map((r) => {
                    let data = regionalData[r];

                    if(!data || !data.data) {
                        return null;
                    }
                    let average = data.average;
                    data = data.data;

                    console.log('data', average)

                    return (
                        <div className="aggregate-data__table-wrapper" key={r}>
                            <table className="aggregate-data-table">
                                <thead>
                                    <tr>
                                        <th
                                            className="users-table__heading"
                                        >
                                            {r}
                                        </th>

                                        {REGIONAL_COLUMNS.map((col, index) => {
                                            return (
                                                <th
                                                    className="users-table__heading"
                                                    key={col.name}
                                                >
                                                    {col.text}
                                                </th>
                                            )
                                        })}
                                    </tr>
                                </thead>

                                <tbody>
                                    {data.map((row, rowIndex) => (
                                        <tr key={rowIndex}>
                                            <td>

                                            </td>

                                            {REGIONAL_COLUMNS.map((col, index) => {
                                                if(col.name === 'herdSize') {
                                                    return (
                                                        <td key={col.name}>
                                                            {renderHerdSize(row)}
                                                        </td>
                                                    );
                                                } else if(col.type === 'dollar') {
                                                    return (
                                                        <td key={index}>
                                                            {renderDollarAmount(row[col.name])}
                                                        </td>
                                                    );
                                                } else {
                                                    return (
                                                        <td key={index}>
                                                            {row[col.name].toLocaleString()}
                                                        </td>
                                                    );
                                                }
                                            })}
                                        </tr>
                                    ))}

                                    <tr>
                                        <td>
                                            Average
                                        </td>

                                        {REGIONAL_COLUMNS.map((col, index) => {
                                            if(col.name === 'herdSize') {
                                                return (
                                                    <td key={col.name}>
                                                        {average.averageHerdSize}
                                                    </td>
                                                );
                                            } else if(col.type === 'dollar') {
                                                return (
                                                    <td key={index}>
                                                        {renderDollarAmount(average[col.name])}
                                                    </td>
                                                );
                                            } else {
                                                return (
                                                    <td key={index}>
                                                        {average[col.name].toLocaleString()}
                                                    </td>
                                                );
                                            }
                                        })}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    );
                })}
            </div>

            <h2>
                Aggregate Profit
            </h2>

            {computedAt && (
                <div className="aggregate-date__computed-at">
                    Computed at: {moment(computedAt).format('MM/DD/YYYY [at] hh:mma')}
                </div>
            )}

            <div className="aggregate-data__table-wrapper aggregate-data-table--global">
                <table className="aggregate-data-table">
                    <thead>
                        <tr>
                            {GLOBAL_COLUMNS.map((col, index) => {
                                return (
                                    <th
                                        className="users-table__heading"
                                        key={col.name}
                                    >
                                        {col.text}
                                    </th>
                                )
                            })}
                        </tr>
                    </thead>

                    <tbody>
                        {globalData && globalData.data && globalData.data.map((row) => (
                            <tr key={row.herdSizeMin}>
                                {GLOBAL_COLUMNS.map((col, index) => {
                                    if(col.name === 'herdSize') {
                                        return (
                                            <td key={col.name}>
                                                {renderHerdSize(row)}
                                            </td>
                                        );
                                    } else if(col.type === 'dollar') {
                                        return (
                                            <td key={index}>
                                                {renderDollarAmount(row[col.name])}
                                            </td>
                                        );
                                    } else {
                                        return (
                                            <td key={index}>
                                                {row[col.name].toLocaleString()}
                                            </td>
                                        );
                                    }
                                })}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <ConfirmModal
                confirmOnClick={handleConfirmDownload}
                confirmText="OK"
                content={auth && auth.user ? `When you click OK, we'll send an email to ${auth.user.user.email} with the data attached as a CSV file.` : ''}
                declineOnClick={() => setShowConfirmModal(false)}
                declineText="Cancel"
                show={showConfirmModal}
                showActivityIndicator={isSendingAggregateData}
                title="Confirmation"
            />

            <ConfirmModal
                confirmOnClick={() => setShowSuccessModal(false)}
                confirmText="OK"
                content={auth && auth.user ? `Your file is being generated and will be sent to ${auth.user.user.email} when completed.` : ''}
                show={showSuccessModal}
                title="Success!"
            />
        </PageContent>
    );
};

AggregateData.propTypes = {

};

const mapStateToProps = (state) => {
    return {
        aggregateData: state.aggregateData,
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        getAggregateData: () => dispatch(getAggregateData()),
        sendAggregateData: () => dispatch(sendAggregateData())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AggregateData);



// WEBPACK FOOTER //
// ./src/containers/AggregateData/index.js